import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, RoutesRecognized } from '@angular/router';
import { Location } from '@angular/common';
// import { Observable } from 'rxjs/Observable';
// import { RouterEnum } from '../../enums/navigation/router.enum';
import { filter, pairwise } from 'rxjs/operators';
import { RouterEnum } from '../enum/navigation/router.enum';
import { Observable } from 'rxjs';

@Injectable()
export class NavigationService {
  private previousUrl: string;

  constructor(
    private _router: Router,
    private _location: Location,
    private _activatedRoute: ActivatedRoute
  ) {  }
  // Navigate to the other view, with or without params
  public navigate<TParam>(where: RouterEnum, params: TParam = null) {
    window.history.pushState({ prevUrl: window.location.href }, 'PreviousUrl', window.location.href)
	  this.previousUrl = window.history.state.prevUrl;
    if (params == null) {
      this._router.navigate([`/${where}`]);
    } else {
      this._router.navigate([`/${where}`], params);
    }
  }
  public params<TType>() {
    return this._activatedRoute.params;
  }
  public paramsMap<TType>() {
    return this._activatedRoute.paramMap;
  }
  /**
   * Get data, that generate resolvers
   * When implement a resolver, need to subscribe to data, for get the data that the resolver produce
   */
  public data<TType>(activatedRoute: ActivatedRoute): Observable<TType> {
    return <any>activatedRoute.data;
  }

  public navigateUrl<TParam>(where: RouterEnum, params: Array<string>) {
    let paramsToSend = '';
    for (const item of params) {
      paramsToSend += `/${item}`;
    }
    this._router.navigate([`/${where}${paramsToSend}`]);
  }
  // Use for navigate to other view, with params in the querystring
  public navigateWithQueryParams<TParam>(
    where: RouterEnum,
    params: TParam = null
  ) {
    if (params == null) {
      this._router.navigate([`/${where}`]);
    } else {
      this._router.navigate([`/${where}`], { queryParams: params });
    }
  }
  public back() {
    this._location.back();
  }
  public getUrl() {
    return this._location.path();
  }
  public getPreviousUrl(): string {
    if(this.previousUrl){
      return this.previousUrl.substr(this.previousUrl.indexOf('#/') + 1);
    }
    return null;
  }


}
export declare interface TData<Type> {
  [name: string]: Type;
}
// This enum contain the definitions of all view's in the applications
